module.exports = __webpack_public_path__ + "img/zanwu.4946bf43.png";